import { Menu, MenuProps } from '@chakra-ui/react';
import { FC, PropsWithChildren, ReactNode } from 'react';

import { useDropdownState } from '../hooks/use-dropdown-state';
import { DropdownContext } from '../lib/context';

export interface DropdownProps extends Omit<MenuProps, 'children'>, PropsWithChildren {
	defaultValue?: any;
	id?: string;
	name?: string;
	onChange?: (value: any) => void;
	onScrollToBottom?: () => void;
	placeholder?: ReactNode;
	renderOption?: (value: any) => ReactNode;
	value?: any;
	valueToString?: (value: any) => string;
}

export const Dropdown: FC<DropdownProps> = ({
	children,
	defaultValue,
	id,
	name,
	onChange,
	onScrollToBottom,
	placeholder,
	renderOption,
	value,
	valueToString,
	...rest
}) => {
	const state = useDropdownState({ defaultValue, onChange, value });

	return (
		<Menu autoSelect={false} offset={[0, 2]} placement="bottom-end" {...rest}>
			{({ isOpen }) => (
				<DropdownContext
					value={{
						id,
						isOpen,
						name,
						onScrollToBottom,
						placeholder,
						renderOption,
						valueToString,
						...state,
					}}
				>
					{children}
				</DropdownContext>
			)}
		</Menu>
	);
};
